import { useRecoilValue } from 'recoil'
import parametersAtom from '@/pages/Parameters/parameters.atom.ts'

const useParameters = () => {
  return useRecoilValue(parametersAtom).items
}

export default useParameters
